import CPTCodes from "./components/cpt-codes";
import ICDCodes from "./components/icd-codes";
import { NoteCodesContextProvider } from "./contexts/NoteCodesContext";
import styles from "./styles.module.scss";

type Props = {
  value?: NoteCodes;
  onUpdate?: undefined | ((arg: NoteCodes) => void);
  readOnly: boolean;
};

const ClientServiceAndDiagnosis = ({ value, onUpdate, readOnly }: Props) => {
  return (
    <NoteCodesContextProvider readOnly={readOnly}>
      <div className={styles["client-service-and-diagnosis"]}>
        <CPTCodes
          codes={value?.service_codes || []}
          onUpdateCodes={(service_codes) =>
            onUpdate && onUpdate({ ...value, service_codes })
          }
        />
        <ICDCodes
          codes={value?.diagnosis_codes || []}
          onUpdateCodes={(diagnosis_codes) =>
            onUpdate && onUpdate({ ...value, diagnosis_codes })
          }
        />
      </div>
    </NoteCodesContextProvider>
  );
};

export default ClientServiceAndDiagnosis;
